import { useNavigate, useLocation } from 'react-router-dom';

const useNavigationWithQuery = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithQuery = (path, options = {}) => {
    const currentQuery = new URLSearchParams(location.search);
    const targetPath = `${path}?${currentQuery}`;
    navigate(targetPath, options);
  };

  return { navigate: navigateWithQuery, queryParams: location.search };
};

export default useNavigationWithQuery;
